import React from "react";
import { TestIds } from "../home";
import { t } from "../../services/locale.service";

const NoPlot = () => {
  return <div data-testid={TestIds.noPlotScreen}>{t("No_plots_found")}</div>;
};

export default NoPlot;
